import { SectorNames } from '../../sectors';

export const fieldsSectorDescription = {
  sector_role: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Роль',
  },
  partnership_id: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Компания',
  },
  region_name: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Регион',
  },
  market_branch: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Филиал',
  },
  city_name: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Город',
  },
  street_type: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Тип улицы',
  },
  street_name: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Улица',
  },
  house_number: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Дом',
  },
  latitude: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Широта',
  },
  longitude: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Долгота',
  },
  sector_head: {
    step: 1,
    sectionName: 'Головной офис участка',
    fieldName: 'Ответственное лицо',
  },
  districts: {
    step: 2,
    sectionName: 'Участок',
    fieldName: 'Район'
  },
  district_coefficients: {
    step: 2,
    sectionName: 'Участок',
    fieldName: 'Коэффициенты районов',
  },
  sector_id: {
    step: 2,
    sectionName: 'Участок',
    fieldName: 'Идентификатор участка',
  },
  migrate_users: {
    step: 2,
    sectionName: 'Изменение участков сотрудников',
    fieldName: 'Новый участок',
  },
};

export interface Responsible {
  full_name: string;
  phone: number;
  user_id?: number;
  u_id?: number;
}

export interface MigrateEmployer {
  employee_type_name: string;
  fullname: string;
  minimal_group_name: string;
  u_id: number;
  sector?: SectorNames;
  sector_id?: number;
  is_checked?: boolean;
}
